export default "__VITE_ASSET__d58ee678__"